import { styled } from "@mui/material/styles"
import { Color } from "../../shared/Expr"

type Props = {
  colors: Color[]
  selectedColor: Color
  colorsPerRow: number
  onSelect: (c: Color) => void
}

const colorSize = 25

export function ColorSelectorGrid({
  selectedColor,
  colors,
  colorsPerRow,
  onSelect,
}: Props) {
  if (!colors) throw `No colors!`
  const width = colorSize * colorsPerRow
  return (
    <ColorGridDiv
      style={{
        width: width,
      }}
    >
      {colors.map((c) => (
        <ColorButtonEl
          key={c}
          color={c}
          onClick={() => {
            onSelect(c)
          }}
          data-selected={c == selectedColor ? "selected" : undefined}
        >
          {c == selectedColor ? "✔" : ""}
        </ColorButtonEl>
      ))}
    </ColorGridDiv>
  )
}

const ColorGridDiv = styled("div")({
  display: "flex",
  flexWrap: "wrap",
})

const ColorButtonEl = styled("button")((props) => ({
  backgroundColor: props.color,
  width: colorSize,
  height: colorSize,
  border: "none",
  cursor: "pointer",
  //color: "rgba(123,123,123,0.5)",
  color: "white",
  textShadow: "0 0 1px rgba(0,0,0,0.4)",
  "&:hover": {
    outline: "2px solid white",
    zIndex: 2,
    boxShadow: "1px 1px 2px 2px rgba(0,0,0,.2)",
  },
  "&[data-selected='selected']": {
    outline: "2px solid white",
    boxShadow: "1px 1px 2px 2px rgba(0,0,0,.2)",
    zIndex: 1,
  },
}))
